import React from 'react';
import { Modal } from 'react-bootstrap-v5';
import { KTSVG } from '../../../../../_metronic/helpers';
import { toAbsoluteUrl } from '../../../../../_metronic/helpers';
import './styles/styles.css';

type Props = {
  show: boolean;
  handleClose: () => void;
};

const AdvantageModal: React.FC<Props> = ({ show, handleClose }) => {
  const dismissModal = () => {
    localStorage.setItem('advantage_modal_shown', new Date().toISOString());
    handleClose();
  };

  return (
    <Modal
      className="modal fade"
      id="kt_modal_select_location"
      data-backdrop="static"
      tabIndex={-1}
      role="dialog"
      show={show}
      aria-hidden="true"
      onHide={dismissModal}
      size="lg"
      centered
      dialogClassName="modal-880"
    >
      <div className="modal-content">
        <div className="modal-header border-0 pb-0 position-relative px-12 pt-6">
          <img alt="Logo" className="logo advantage-modal-logo" src={toAbsoluteUrl('/media/logos/logo-idefix.svg')} />
          <div className="btn btn-icon btn-sm btn-active-light-primary ms-2 advantage-modal-close" onClick={dismissModal}>
            <KTSVG path="/media/icons/duotone/Navigation/Close.svg" className="svg-icon-2x" />
          </div>
        </div>

        <div className="modal-body text-center pt-7 px-12">
          <div className="d-flex align-items-center justify-content-center gap-6 mb-4">
            <KTSVG path="/media/icons/duotone/Communication/Announcement.svg" className="svg-icon-3x" />
            <h2 className="fw-semibold mb-0 advantage-modal-title">Barem Altı Avantajlı Kargo Fırsatı</h2>
          </div>

          <p className="mb-6 advantage-modal-text">
            İş ortaklarımızın kargo maliyetlerini azaltmak ve operasyonel verimliliğinizi arttırmak amacıyla 'Barem Altı Avantajlı Kargo Uygulamasını' başlatıyoruz!
          </p>

          <h3 className="text-start advantage-modal-text-bold">Kampanya Detayları;</h3>

          <ul className="text-start mb-8 advantage-modal-text">
            <li>
              <span className="advantage-modal-text-bold">Platform Öder Kargo Profil Tipini kullanan ve 250 TL altındaki siparişler için gönderim yapan </span>
              iş ortaklarımıza, standart tarifelerin dışında özel kargo avantajları sunduk.
            </li>
            <li>
              250 TL üzerindeki siparişler için desi bazlı güncel kargo fiyatları uygulanmaya devam edecektir.{' '}
              <span style={{ fontStyle: 'italic' }}>(Güncel kargo fiyatlarına kargo işlemleri menüsünden ulaşabilirsiniz.)</span>
            </li>
          </ul>

          <div className="row g-6 mb-8">
            <div className="col-6">
              <div className="rounded p-8 h-100 advantage-modal-box">
                <div className="advantage-modal-box-text mb-3">
                  0 - 149,99 TL arasındaki
                  <br />
                  siparişlerinizdeki kargo tutarı
                  <br />
                  üzerinden;
                </div>
                <div className="advantage-modal-price mb-3">50 TL</div>
                <div className="advantage-modal-box-text-bold">Kargo ücreti indirimi uygulanacaktır!</div>
              </div>
            </div>
            <div className="col-6">
              <div className="rounded p-6 h-100 advantage-modal-box">
                <div className="advantage-modal-box-text mb-3">
                  150,00 - 249,99 TL arasındaki
                  <br />
                  siparişlerinizdeki kargo tutarı
                  <br />
                  üzerinden;
                </div>
                <div className="advantage-modal-price mb-3">20 TL</div>
                <div className="advantage-modal-box-text-bold">Kargo ücreti indirimi uygulanacaktır!</div>
              </div>
            </div>
          </div>

          <p className="advantage-modal-footer-text">
            Barem Altı Avantajlı Kargo Fırsatı ve diğer tüm konularda destek alabilmeniz için
            <strong> 0850 474 12 00</strong> numaralı satıcı destek hattımızdan bizlere ulaşabilir veya panelinizdeki <strong>'Destek Taleplerim'</strong> başlığı altından kayıt
            oluşturabilirsiniz.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default AdvantageModal;
